module.exports = __webpack_public_path__ + "static/media/atom.516d0b09.svg";